import { Tabs, TabList, TabPanels, Tab, TabPanel, Flex, Box } from '@chakra-ui/react';
import { useLocation, Link } from 'react-router-dom';
import CheckRank from '../components/checkRank';
import BadgeRank from '../components/badges/index';
import CustomRankPage from '../pages/customRank';
import Layout from '../components/layouts/main';
import { LockIcon } from '@chakra-ui/icons';
import { useUser } from '../context/UserContext';

const TabbedPage = () => {
	const location = useLocation();
	const path = location.pathname;
	const { user } = useUser();
	const isUserHasKey = user && user.mintedKey;

	// Determine the default index based on the current path
	const getDefaultIndex = () => {
		if (path === '/check-badges-rank') return 1;
		if (path === '/check-custom-rank') return 2;
		return 0;
	};

	return (
		<Layout>
			<Tabs variant='soft-rounded' colorScheme='orange' defaultIndex={getDefaultIndex()} align='center'>
				<TabList>
					<Tab>
						<Link to="/check-marks-rank" style={{ textDecoration: 'none', color: 'inherit' }}>
							<Flex align='center'>
								<Box>Marks</Box>
							</Flex>
						</Link>
					</Tab>
					<Tab>
						<Link to="/check-badges-rank" style={{ textDecoration: 'none', color: 'inherit' }}>
							<Flex align='center'>
								<Box>Badges</Box>
							</Flex>
						</Link>
					</Tab>
					<Tab>
						<Link to="/check-custom-rank" style={{ textDecoration: 'none', color: 'inherit' }}>
							<Flex align='center'>
								{!isUserHasKey ? <LockIcon mr={2} /> : ''}
								<Box>Custom</Box>
							</Flex>
						</Link>
					</Tab>
				</TabList>

				<TabPanels>
					<TabPanel>
						<CheckRank />
					</TabPanel>
					<TabPanel>
						<BadgeRank />
					</TabPanel>
					<TabPanel>
						<CustomRankPage isUserHasKey={isUserHasKey} />
					</TabPanel>
				</TabPanels>
			</Tabs>
		</Layout>
	);
};

export default TabbedPage;
